import { getSagaContext } from "@modules/store/redux/sagaContext"
import { ThemeMode } from "@ui/types"
import { call, put } from "typed-redux-saga"
import { uiActions } from "../state"
import { UiStoreKeys } from "../storage"

export function* initializeUi() {
  const storage = yield* getSagaContext("store")
  const mode = yield* call(storage.get, UiStoreKeys.ThemeMode)
  const sidebarCollapsed = yield* call(
    storage.get,
    UiStoreKeys.SidebarCollapsed
  )

  yield* put(
    uiActions.initializeCompleted({
      mode: mode as ThemeMode,
      sidebarCollapsed: sidebarCollapsed as boolean,
    })
  )
}
